import { supabase } from "@/integrations/supabase/client";

export const QdrantIndexer = {
  async indexKbText(params: { tenant_id: string; kb_id: string; text_id: string; title?: string | null; content: string }) {
    const { error } = await supabase.functions.invoke("ai-qdrant-index", { body: params } as any);
    if (error) throw error;
  },
};

